var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMenuPaymentHistory = function SvgIconMenuPaymentHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 27,
    viewBox: "0 0 30 27"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 0A13.333 13.333 0 0 0 3.343 13.072L0 13.333l5.139 4.444 3.75-5.139-3.312.262A11.114 11.114 0 1 1 8.9 21.263l-1.83 1.306A13.327 13.327 0 1 0 16.667 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.777 6.036a1.15 1.15 0 0 0-1.1 1.191v7.047a1.2 1.2 0 0 0 .42.917l5.6 4.7a1.084 1.084 0 0 0 1.573-.183 1.214 1.214 0 0 0-.175-1.651l-5.176-4.345V7.229a1.2 1.2 0 0 0-.328-.848 1.1 1.1 0 0 0-.814-.345"
  }))));
};
export default SvgIconMenuPaymentHistory;